module.exports = __webpack_public_path__ + "static/img/cmdb_bot.924ab321.svg";